
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eJPDm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abad520f5079515b$var$_react = $abad520f5079515b$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $abad520f5079515b$var$_radioChecked = $abad520f5079515b$var$_interopRequireDefault((parcelRequire("2kmFP")));
function $abad520f5079515b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $abad520f5079515b$var$RadioIcon = (props)=>/*#__PURE__*/ $abad520f5079515b$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $abad520f5079515b$var$_radioChecked.default
    }));
$abad520f5079515b$var$RadioIcon.displayName = 'RadioIcon';
var $abad520f5079515b$var$_default = module.exports.default = $abad520f5079515b$var$RadioIcon;

});


//# sourceMappingURL=radio.053b9a0f.js.map
